<div class="h-100 d-flex flex-column">
    <app-breadcrumb></app-breadcrumb>

    <div class="card mb-0 mt-3 flex-grow-1">
        <div class="card-body flex-column flex-nowrap">
            <div class="row">
                <div class="col-auto">
                    <button type="button" class="btn btn-sm btn-primary" (click)="clickOpenModalCompanyInfo(DtgActionType.update)">
                        회사목록
                    </button>
                </div>
                <div class="col-auto">
                    <select class="form-control form-control-sm" [(ngModel)]="selectedVideo">
                        <option *ngFor="let item of getListDeviceByType('videoinput');" [ngValue]="item">
                            {{item.label}}
                        </option>
                    </select>
                </div>
                <!-- <div class="col-auto">
                    <select class="form-control form-control-sm" [(ngModel)]="selectedAudio">
                        <option *ngFor="let item of getListDeviceByType('audioinput');" [ngValue]="item">
                            {{item.label}}
                        </option>
                    </select>
                </div> -->
                <div class="col-auto">
                    <button type="button" class="btn btn-sm btn-primary"
                        (click)="playVideo()">
                        play
                    </button>
                    <button type="button" class="btn btn-sm btn-info"
                        (click)="stopVideo()">
                        stop
                    </button>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-auto">
                    <video controls class="w-100 h-100" style="max-width:100vw;max-height:50vh;" #video01></video>
                </div>
            </div>
        </div>
    </div>
</div>
